import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_roen_1: FaireProductEntity = {
  token: "legacy_prod_roen-1",
  type: "product",
  name: "La Condesa",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a15d1fc087908754991b018a69774258782ff3fad6f50ef4078fe96c26a1caf6.webp",
  galleryImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/4aba30fa60e653c4f5417885f3b1b47c6ceb899b7bfdd856851b62999d9aa0eb.webp",
    "https://cdn.prerelease.faire.dev/fastly/7ea32437a72e81240c3f18c5af2d30d61a63a554097f2748eb2ae443bbc7155e.webp",
    "https://cdn.prerelease.faire.dev/fastly/5d19f84001260378a20e8d8c516c3344c0ebdac9a0a761af73a283ce96fc2bbd.webp",
    "https://cdn.prerelease.faire.dev/fastly/a223980565ac674c122c53f7df19b8dbb533cf4ea8942693b37a8e3c5b8bc97a.webp",
    "https://cdn.prerelease.faire.dev/fastly/341337855938ccbc025b9b17d4ca6f9e341f97d90d45f8e5dd13f1b304b4793b.webp",
  ],
  priceDollars: 19,
  msrpDollars: 38,
  freeShipping: true,
  brandAvatarUrl: "/images/ROEN/Brand%20Page/roen-avatar.webp",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 2,
  },
  brandToken: "catalog_brand_roen",
  description:
    "La Condesa is an 8oz candle featuring bright notes of citrus, white florals, and lush greenery. Made with a clean coconut-soy wax blend in a hand-painted, reusable jar. Vegan, cruelty-free, and paraben-free. Perfect 5.0-star rating from 15 reviews. Wholesale is $18.00 with a $10.00 tester option available.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["Top 5% in home decor", "Only 3 left", "Faire Source"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
